var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextWithHighlight"},[_c('div',{staticClass:"text",class:[("theme--" + _vm.theme)],domProps:{"innerHTML":_vm._s(_vm.$options.filters.markTextRange(_vm.text, _vm.range))}})])}
var staticRenderFns = []

export { render, staticRenderFns }